module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/lagoon/lagoon-03_layoutphoto_03.png";